import { Report } from "../../report"

export const navigationReport = Report.namespace(`navigation`)
